
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sangjo/goi",
      function () {
        return require("private-next-pages/sangjo/goi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sangjo/goi"])
      });
    }
  